import React, { useState , useCallback, useEffect } from 'react';
import { AppBar, Box, Button, Typography, Avatar, Grid, IconButton, Dialog  } from '@mui/material';
import expIcon from "../../images/icons/exp_icon.svg";
import fnbIcon from "../../images/icons/fnb_icon.svg";
import { useNavigate , useParams } from 'react-router-dom';
import { Logout as LogoutIcon, History as HistoryIcon, } from '@mui/icons-material';
import Login from '../Login';
import { navigateWithHostelParams } from '../../components/NavigateWithHostelParams';
import Swal from 'sweetalert2';
import { CategoryButton } from './CategoryButton';
import { getHostelData } from '../../api/services/FetchNodeService';





const Menu = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("TOKEN");
  const [isLoginDialogOpen, setIsLoginDialogOpen] = useState(false);
  const { hostel_name, hostel_id , locations } = useParams();
  const [hostelData, setHostelData] = useState([]);
  const hostelName = localStorage.getItem("hostel_name");


   localStorage.setItem("locations", locations);
  const storedlocations = localStorage.getItem("locations");

  // Use whichever is available (URL param takes precedence)
  const currentlocations = locations || storedlocations;

  const fetchHostelData = useCallback(async () => {
    try {
      const response = await getHostelData(`hostel/food-menu/${hostel_id}`);

      // if(response && response.data){
      console.log(response);
      const hostel = response.data;
      setHostelData(hostel);
    } catch (e) {
      console.log(e);
    }
  }, [hostel_id]);

  useEffect(() => {
    fetchHostelData();
  }, [fetchHostelData]);

  const storedHostelName = localStorage.getItem("hostel_name");
  const storedHostelId = localStorage.getItem("hostel_id");

  // Handle the initial setup or mismatch
  React.useEffect(() => {
    if (!storedHostelName && !storedHostelId) {
      localStorage.setItem("hostel_id", hostel_id);
      localStorage.setItem("hostel_name", hostel_name);
    } else if (
      storedHostelName !== hostel_name ||
      storedHostelId !== hostel_id
    ) {
      console.log("Hostel name or hostel ID mismatch");
      localStorage.clear();
      Swal.fire({
        title: "Property Change Detected",
        text: "You are jumping into a new OHSM property. Refreshing the page...",
        icon: "info",
        confirmButtonText: "OK",
      }).then(() => {
        // Reset localStorage to the new hostel details
        localStorage.setItem("hostel_id", hostel_id);
        localStorage.setItem("hostel_name", hostel_name);

        // Refresh the page to ensure the app reflects the new property
        window.location.reload();
      });
    }
  }, [hostel_name, hostel_id, storedHostelId, storedHostelName]);

  // localStorage.setItem("hostel_id", hostel_id);
  // localStorage.setItem("hostel_name", hostel_name);

  const handleLoginSuccess = () => {
    setIsLoginDialogOpen(false);
    console.log("User logged in successfully!");
    // Proceed with order placement or any post-login actions
  };

  // Enhanced logout handler
  const handleLogout = useCallback(
    (isSessionExpired = false) => {
      try {
        // Store hostel info before clearing
        const hostelId = localStorage.getItem("hostel_id");
        const hostelName = localStorage.getItem("hostel_name");

        // Clear all session and user-specific data
        const itemsToKeep = ["hostel_id", "hostel_name"];
        Object.keys(localStorage).forEach((key) => {
          if (!itemsToKeep.includes(key)) {
            localStorage.removeItem(key);
          }
        });

        // Clear any Redux state if needed
        // dispatch(clearUserData()); // Add your Redux clear action if needed

        // Force a state update
        window.dispatchEvent(new Event("storage"));

        // Navigate to login with preserved hostel parameters
        navigateWithHostelParams(navigate, "/food-menu", {
          hostel_id: hostelId,
          hostel_name: hostelName,
          locations: currentlocations,

          state: {
            loggedOut: true,
            sessionExpired: Boolean(isSessionExpired),
          },
          replace: true, // Important: prevent back navigation
        });
        // Refresh the page after fallback navigation
        window.location.reload();
      } catch (error) {
        console.error("Logout error:", error);
        // Fallback navigation
        const hostelId = localStorage.getItem("hostel_id");
        const hostelName = localStorage.getItem("hostel_name");
        navigate(`/hostel_name/${hostelName}/hostel_id/${hostelId}/login`, {
          replace: true,
          state: { error: true },
        });
        // Refresh the page after fallback navigation
        window.location.reload();
      }
    },
    [navigate, currentlocations]
  );

  // Periodic session check

  const handleOrderHistory = useCallback(() => {
    const token = localStorage.getItem("TOKEN");
    if (!token) {
      setIsLoginDialogOpen(true); // Open login dialog if user is not authenticated
    } else {
      navigateWithHostelParams(navigate, "/order-history", {
        state: { fromMenu: true },
      });
    }
  }, [navigate]);

  // Usage in your app:

  return (
    <>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#f5f5f5",
          height: "100vh",
          width: "auto",
        }}
      >
       
        <AppBar position="static" color="transparent" elevation={0}>
          <Grid container alignItems="center">
            {/* Top Left - Order History Button */}
            <Grid item xs={4} display="flex" justifyContent="flex-start">
              <Button
                startIcon={<HistoryIcon />}
                onClick={handleOrderHistory}
                sx={{ fontWeight: "bold", color: "primary.main" }}
              >
                Order History
              </Button>
            </Grid>

            {/* Center - Hostel Name */}
            <Grid item xs={4} display="flex" justifyContent="center">
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                {hostelName || hostel_name}
              </Typography>
            </Grid>

            {/* Top Right - Logout Button */}
            {token && (
              <>
                <Grid item xs={4} display="flex" justifyContent="flex-end">
                  <IconButton onClick={handleLogout} color="primary">
                    <LogoutIcon />
                  </IconButton>
                </Grid>
              </>
            )}
          </Grid>
        </AppBar>
        
        <Box sx={{ borderBottom: "1px solid #E5E7EB", margin: "16px 0" }} />
        <Box sx={{ textAlign: "left", marginTop: 3 }}>
          <Typography sx={{ fontWeight: "bold" }}>Dear Guest,</Typography>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontSize: 14 }}
          >
            Explore our F&B and Experiences & Merchandise menus!
          </Typography>
        </Box>
        <Button
          variant="outlined"
          sx={{
            borderRadius: "24px",
            padding: "4px 16px",
            textTransform: "none",
            fontWeight: "bold",
            color: "#d63384",
            borderColor: "#d63384",
            marginBottom: "16px",
            marginTop: "16px",
          }}
        >
          Menu
        </Button>
        <CategoryButton
          icon={<Avatar src={fnbIcon} variant="rounded" />}
          parentSubCat="fnb" // Pass 'fnb' as the parent_sub_cat
          label="Food & Beverage"
          hostel_id={hostel_id}
        />
        {/* <CategoryButton
          icon={<Avatar src={expIcon} variant="rounded" />}
          parentSubCat="exp" // Pass 'exp' as the parent_sub_cat
          label="Experiences & Merchandise"
        /> */}
        {!["Cafe", "Cafe - QR Only"].includes(hostelData.property_type) && (
          <CategoryButton
            icon={<Avatar src={expIcon} variant="rounded" />}
            parentSubCat="exp"
            label="Experiences & Merchandise"
          />
        )}
      </Box>

      <Dialog
        open={isLoginDialogOpen}
        onClose={() => setIsLoginDialogOpen(false)}
        aria-labelledby="login-dialog-title"
      >
        <Login
          onLoginSuccess={handleLoginSuccess}
          onClose={() => setIsLoginDialogOpen(false)}
        />
      </Dialog>
    </>
  );
};

export default Menu;



// import React, { useState, useCallback, useEffect } from "react";
// import {
//   AppBar,
//   Box,
//   Button,
//   Typography,
//   Avatar,
//   Grid,
//   IconButton,
//   Dialog,
//   Toolbar,
//   Drawer,
//   List,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Divider,
//   useTheme,
//   useMediaQuery,
// } from "@mui/material";
// import expIcon from "../../images/icons/exp_icon.svg";
// import fnbIcon from "../../images/icons/fnb_icon.svg";
// import { useNavigate, useLocation, useParams } from "react-router-dom";
// import {
//   Logout as LogoutIcon,
//   History as HistoryIcon,
//   Menu as MenuIcon,
// } from "@mui/icons-material";
// import Login from "../Login";
// import { navigateWithHostelParams } from "../../components/NavigateWithHostelParams";
// import Swal from "sweetalert2";
// import { CategoryButton } from "./CategoryButton";
// import { getHostelData } from "../../api/services/FetchNodeService";

// const Menu = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const token = localStorage.getItem("TOKEN");
//   const [isLoginDialogOpen, setIsLoginDialogOpen] = useState(false);
//   const { hostel_name, hostel_id, locations } = useParams();
//   const [hostelData, setHostelData] = useState([]);
//   const [hostelName, setHostelName] = useState(
//     localStorage.getItem("hostel_name")
//   );

//   const [drawerOpen, setDrawerOpen] = useState(false);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//   localStorage.setItem("locations", locations);
//   const storedlocations = localStorage.getItem("locations");
//   const currentlocations = locations || storedlocations;

//   const fetchHostelData = async () => {
//     try {
//       const response = await getHostelData(`hostel/food-menu/${hostel_id}`);
//       const hostel = response.data;
//       setHostelData(hostel);
//     } catch (e) {
//       console.log(e);
//     }
//   };

//   useEffect(() => {
//     fetchHostelData();
//   }, [hostel_name, hostel_id]);

//   const storedHostelName = localStorage.getItem("hostel_name");
//   const storedHostelId = localStorage.getItem("hostel_id");

//   // Handle the initial setup or mismatch
//   React.useEffect(() => {
//     if (!storedHostelName && !storedHostelId) {
//       localStorage.setItem("hostel_id", hostel_id);
//       localStorage.setItem("hostel_name", hostel_name);
//     } else if (
//       storedHostelName !== hostel_name ||
//       storedHostelId !== hostel_id
//     ) {
//       console.log("Hostel name or hostel ID mismatch");
//       localStorage.clear();
//       Swal.fire({
//         title: "Property Change Detected",
//         text: "You are jumping into a new OHSM property. Refreshing the page...",
//         icon: "info",
//         confirmButtonText: "OK",
//       }).then(() => {
//         localStorage.setItem("hostel_id", hostel_id);
//         localStorage.setItem("hostel_name", hostel_name);
//         window.location.reload();
//       });
//     }
//   }, [hostel_name, hostel_id, storedHostelId, storedHostelName]);

//   const handleLoginSuccess = () => {
//     setIsLoginDialogOpen(false);
//     console.log("User logged in successfully!");
//   };

//   const handleLogout = useCallback(
//     (isSessionExpired = false) => {
//       try {
//         const hostelId = localStorage.getItem("hostel_id");
//         const hostelName = localStorage.getItem("hostel_name");

//         const itemsToKeep = ["hostel_id", "hostel_name"];
//         Object.keys(localStorage).forEach((key) => {
//           if (!itemsToKeep.includes(key)) {
//             localStorage.removeItem(key);
//           }
//         });

//         window.dispatchEvent(new Event("storage"));

//         navigateWithHostelParams(navigate, "/food-menu", {
//           hostel_id: hostelId,
//           hostel_name: hostelName,
//           locations: currentlocations,
//           state: {
//             loggedOut: true,
//             sessionExpired: Boolean(isSessionExpired),
//           },
//           replace: true,
//         });
//         window.location.reload();
//       } catch (error) {
//         console.error("Logout error:", error);
//         const hostelId = localStorage.getItem("hostel_id");
//         const hostelName = localStorage.getItem("hostel_name");
//         navigate(`/hostel_name/${hostelName}/hostel_id/${hostelId}/login`, {
//           replace: true,
//           state: { error: true },
//         });
//         window.location.reload();
//       }
//     },
//     [navigate]
//   );

//   const handleOrderHistory = useCallback(() => {
//     const token = localStorage.getItem("TOKEN");
//     if (!token) {
//       setIsLoginDialogOpen(true);
//     } else {
//       navigateWithHostelParams(navigate, "/order-history", {
//         state: { fromMenu: true },
//       });
//     }
//   }, [navigate]);

//   const toggleDrawer = (open) => () => {
//     setDrawerOpen(open);
//   };

//   // Property logo (fallback to initials/avatar)
//   const propertyLogoUrl =
//     hostelData?.logo_url ||
//     hostelData?.property_logo ||
//     hostelData?.hostel_logo ||
//     null;

//   const propertyInitials = (hostelName || hostel_name || "OHSM")
//     .split(" ")
//     .map((w) => w[0])
//     .join("")
//     .toUpperCase()
//     .slice(0, 2);

//   const drawerContent = (
//     <Box
//       sx={{ width: 260, pt: 2 }}
//       role="presentation"
//       onClick={toggleDrawer(false)}
//       onKeyDown={toggleDrawer(false)}
//     >
//       <Box sx={{ display: "flex", alignItems: "center", px: 2, mb: 1 }}>
//         <Avatar
//           src={propertyLogoUrl || undefined}
//           alt={hostelName || hostel_name}
//           sx={{
//             width: 40,
//             height: 40,
//             mr: 1.5,
//             bgcolor: propertyLogoUrl ? "transparent" : "#111827",
//             fontSize: 16,
//             fontWeight: 600,
//           }}
//         >
//           {!propertyLogoUrl && propertyInitials}
//         </Avatar>
//         <Box>
//           <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
//             {hostelName || hostel_name}
//           </Typography>
//           {hostelData?.property_type && (
//             <Typography variant="caption" sx={{ color: "text.secondary" }}>
//               {hostelData.property_type}
//             </Typography>
//           )}
//         </Box>
//       </Box>

//       <Divider sx={{ mb: 1 }} />

//       <List>
//         <ListItemButton onClick={handleOrderHistory}>
//           <ListItemIcon>
//             <HistoryIcon fontSize="small" />
//           </ListItemIcon>
//           <ListItemText primary="Order History" />
//         </ListItemButton>

//         {token && (
//           <ListItemButton onClick={() => handleLogout(false)}>
//             <ListItemIcon>
//               <LogoutIcon fontSize="small" />
//             </ListItemIcon>
//             <ListItemText primary="Logout" />
//           </ListItemButton>
//         )}
//       </List>
//     </Box>
//   );

//   return (
//     <>
//       <Box
//         sx={{
//           padding: { xs: "16px", md: "24px" },
//           backgroundColor: "#f5f5f5",
//           minHeight: "100vh",
//           width: "auto",
//         }}
//       >
//         {/* --- Redesigned Minimal Professional AppBar --- */}
//         <AppBar
//           position="static"
//           color="inherit"
//           elevation={0}
//           sx={{
//             borderRadius: 2,
//             px: { xs: 1, md: 2 },
//             py: 0.5,
//             backgroundColor: "#ffffff",
//             border: "1px solid #E5E7EB",
//           }}
//         >
//           <Toolbar
//             disableGutters
//             sx={{ minHeight: 56, px: { xs: 1.5, md: 2 } }}
//           >
//             {/* Center-left: Property Logo + Name */}
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 flexGrow: 1,
//                 minWidth: 0,
//               }}
//             >
//               <Avatar
//                 src={propertyLogoUrl || undefined}
//                 alt={hostelName || hostel_name}
//                 sx={{
//                   width: 36,
//                   height: 36,
//                   mr: 1.5,
//                   bgcolor: propertyLogoUrl ? "transparent" : "#111827",
//                   fontSize: 14,
//                   fontWeight: 600,
//                 }}
//               >
//                 {!propertyLogoUrl && propertyInitials}
//               </Avatar>
//               <Box
//                 sx={{
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                   whiteSpace: "nowrap",
//                 }}
//               >
//                 <Typography
//                   variant="subtitle1"
//                   sx={{ fontWeight: 600, lineHeight: 1.2 }}
//                 >
//                   {hostelName || hostel_name}
//                 </Typography>
//                 {/* {hostelData?.property_type && (
//                   <Typography
//                     variant="caption"
//                     sx={{ color: "text.secondary", lineHeight: 1.2 }}
//                   >
//                     {hostelData.property_type}
//                   </Typography>
//                 )} */}
//               </Box>
//             </Box>

//             {/* Left: Hamburger Menu */}
//             <IconButton
//               edge="start"
//               onClick={toggleDrawer(true)}
//               sx={{ mr: 1.5 }}
//             >
//               <MenuIcon />
//             </IconButton>

//             {/* Right side actions for larger screens */}
//             {/* {!isMobile && (
//               <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                 <Button
//                   startIcon={<HistoryIcon />}
//                   onClick={handleOrderHistory}
//                   sx={{
//                     textTransform: "none",
//                     fontWeight: 500,
//                     color: "text.primary",
//                   }}
//                 >
//                   Order History
//                 </Button>

//                 {token && (
//                   <IconButton
//                     onClick={() => handleLogout(false)}
//                     sx={{
//                       borderRadius: 999,
//                       border: "1px solid #E5E7EB",
//                     }}
//                   >
//                     <LogoutIcon fontSize="small" />
//                   </IconButton>
//                 )}
//               </Box>
//             )} */}
//           </Toolbar>
//         </AppBar>

//         {/* Divider under AppBar */}
//         <Box sx={{ borderBottom: "1px solid #E5E7EB", margin: "16px 0" }} />

//         {/* Content */}
//         <Box sx={{ textAlign: "left", marginTop: 3 }}>
//           <Typography sx={{ fontWeight: "bold" }}>Dear Guest,</Typography>
//           <Typography
//             variant="subtitle1"
//             sx={{ fontWeight: 500, fontSize: 14 }}
//           >
//             Explore our F&amp;B and Experiences &amp; Merchandise menus!
//           </Typography>
//         </Box>

//         <Button
//           variant="outlined"
//           sx={{
//             borderRadius: "24px",
//             padding: "4px 16px",
//             textTransform: "none",
//             fontWeight: "bold",
//             color: "#d63384",
//             borderColor: "#d63384",
//             marginBottom: "16px",
//             marginTop: "16px",
//           }}
//         >
//           Menu
//         </Button>

//         <CategoryButton
//           icon={<Avatar src={fnbIcon} variant="rounded" />}
//           parentSubCat="fnb"
//           label="Food & Beverage"
//           hostel_id={hostel_id}
//         />

//         {!["Cafe", "Cafe - QR Only"].includes(hostelData.property_type) && (
//           <CategoryButton
//             icon={<Avatar src={expIcon} variant="rounded" />}
//             parentSubCat="exp"
//             label="Experiences & Merchandise"
//           />
//         )}
//       </Box>

//       {/* Drawer for mobile / hamburger menu */}
//       <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
//         {drawerContent}
//       </Drawer>

//       {/* Login dialog */}
//       <Dialog
//         open={isLoginDialogOpen}
//         onClose={() => setIsLoginDialogOpen(false)}
//         aria-labelledby="login-dialog-title"
//       >
//         <Login
//           onLoginSuccess={handleLoginSuccess}
//           onClose={() => setIsLoginDialogOpen(false)}
//         />
//       </Dialog>
//     </>
//   );
// };

// export default Menu;
